import React from 'react';
import { ComparisonDetailMembersDataType } from '../../types';
import { useTranslation } from 'react-i18next';
import './MatchStatSection.css';

type Props = {
    comparison: ComparisonDetailMembersDataType['comparison'];
    dateFrom: string | undefined;
    dateTo: string | null;
};

const MatchStatSection = ({ comparison, dateFrom, dateTo }: Props) => {
    const { t } = useTranslation(['analyses', 'translation']);

    return (
        <>
            <div className='comparison-match-container'>
                <p className='match-percentage'>{comparison?.match_stat.toFixed(2)}%</p>
                <p className='match-text'>{t('voting-agreement', { ns: 'translation' })}</p>
            </div>
            <p id='mandate-date-text'>
                {dateFrom && dateTo ? (
                    <>
                        {t('mandate-date')} {t('from')} {dateFrom} {t('to')} {dateTo}.
                    </>
                ) : dateFrom ? (
                    <>
                        {t('mandate-date')} {t('from')} {dateFrom}.
                    </>
                ) : dateTo ? (
                    <>
                        {t('mandate-date')} {t('to')} {dateTo}.
                    </>
                ) : (
                    <>{t('mandate-entire-term')}</>
                )}
            </p>
        </>
    );
};

export default MatchStatSection;
